import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "../button/button.component";

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { CorrelationIdService } from '../../../core/services/correlation-id.service';

@Component({
  selector: 'app-validation-message',
  imports: [ButtonComponent, TranslateModule, NgClass],
  templateUrl: './validation-message.component.html',
  styleUrl: './validation-message.component.css'
})
export class ValidationMessageComponent {
  constructor(
    private translateService: TranslateService,
    private correlationIdService: CorrelationIdService
  ) {}

  @Input() title: string = ""
  @Input() showTypeIcon: boolean = true;
  @Input() showCloseIcon: boolean = false;
  @Input() message: string = ""
  @Input() type: 'info' | 'warning' | 'error' | 'success' | 'default' = 'default';
  @Input() showbutton: boolean = false;
  @Input() buttonText: string = '';
  @Input() startNewText: string = '';

  @Output() closed = new EventEmitter<void>();
  @Output() onItemClick = new EventEmitter<string>();

  @Input() content: {
    title?: string;
    message?: string;
    sections?: {
      title: string;
      items: string[];
    }[];
  } = {
      sections: [],
    };
  @Output() onBtnClick = new EventEmitter<any>();
  messageShow: boolean = true;

  // This method is used to handle click event using value
  onClick(value: any) {
    this.onBtnClick.emit(value);
  }

  // This method is used to emit section item click
  itemClicked(item: string) {
    this.onItemClick.emit(item);
  }
  // This method is used to hide message
  hideMessage() {
    this.messageShow = false;
    this.closed.emit();
  }
  get iconPath(): string {
    switch (this.type) {
      case 'success': return '/icons/svg/card-success.svg';
      case 'error': return '/icons/svg/error.svg';
      case 'warning': return '/icons/svg/warning.svg';
      case 'info': return '/icons/svg/info.svg';
      default: return '/icons/svg/info.svg';
    }
  }

  get displayContentMessage(): string {
    const message = this.content.message || '';
    const translatedMessage = this.translateService.instant(message);
    const technicalErrorKey = 'TOAST_MESSAGES.TECHNICAL_ERROR';
    const technicalErrorMessage = this.translateService.instant(technicalErrorKey);
    const isTechnicalError = message === technicalErrorKey || translatedMessage === technicalErrorMessage;

    if (!isTechnicalError) {
      return translatedMessage;
    }

    const correlationId = this.correlationIdService.getTechnicalErrorCorrelationId();
    if (!correlationId) {
      return translatedMessage;
    }

    const supportMessage = this.translateService.instant(
      'TOAST_MESSAGES.TECHNICAL_ERROR_CORRELATION',
      { correlationId }
    );
    return `${translatedMessage}<br>${supportMessage}`;
  }
}
